/**
 * Repopulate dropdown from JSON string
 *
 * @param type
 * @param json
 */

/**
 * Fires ajax search to auto trader search API
 *
 * @param string url
 */
var search_running = false;

import { initAccordion } from '../../../sites/petervardy/js/global/accordion';
import { initToggleLayout } from '../../../sites/petervardy/js/search/toggle-layout'
import { initToggleFilters } from '../../../sites/petervardy/js/search/toggle-filters'
import { initInfoPopup } from '../../../sites/petervardy/js/search/info-popup'
import { initReadMoreScroll } from '../../../sites/petervardy/js/search/read-more-scroll'

window.ajaxSearch = function ajaxSearch(url, searchType, remove) {

    /* ------------------------------ */
    /* force strict mode  */
    /* ------------------------------ */
    "use strict";

    searchType = typeof searchType !== 'undefined' ? searchType : 'search';
    remove = typeof remove !== 'undefined' ? remove : false;
    //remove TrailingSlash from url
    url = url.replace(/\/$/, "");
    var display_url = '',
        mobile = 0,
        page_id,
        franchise_exists = 0;

    if (searchType === 'search') {
        url = url.replace(/\/search\/?/, "/ajax-search/");
    } else if (searchType === 'searchForm') {
        url = '/modules/Search/search_form_ajax.php?url=' + url + '&http_referer=' + location.pathname;
        page_id = $('#searchFormWrap').data('page-id');
        franchise_exists = $('#searchFormWrap').data('franchise-exists');
    }

    if ($(window).width() <= 1060) {
        mobile = 1;
    }

    var search_form_type = 'default';

    if ($('#searchFormWrap').hasClass('slimSearchWrap')) {
        search_form_type = 'slim';
    }

    // Hide LiveChat when Carz Wyton dealership selected
    if (url.includes('10029752')) {
        $('body').addClass('chatHidden')
    } else {
        $('body').removeClass('chatHidden')
    }

    $.ajax({
        url: url,
        type: "get",
        data: {
            mobile: mobile,
            page_id: page_id,
            franchise_exists: franchise_exists
        },
        beforeSend: function () {
            if (search_form_type != 'slim') {
                $('#loadingOverlay').fadeIn(500);
            } else {
                $('#loadingOverlay').show();
            }
            window.search_running = true;
        },
        complete: function () {
            checkCashOrMonthly();

            //$('.checkboxToggle').removeAttr('checked');

            if ($('.searchResults').data('title')) {
                document.title = $('.searchResults').data('title');
            }

            window.search_running = false;

            if (search_form_type != 'slim') {
                $('#loadingOverlay').fadeOut(500);
            } else {
                $('#loadingOverlay').hide();
            }

            lazyLoadedImages.update();

            const accordions = Array.from(document.getElementsByClassName('js_accordion'));
            accordions.forEach(accordion => initAccordion(accordion, accordions));

            initToggleLayout()
            initToggleFilters()
            initInfoPopup()
            initReadMoreScroll()
        },
        success: function (response) {

            if (searchType === 'search') {

                display_url = url.replace('/ajax-search', '/search');

                window.history.pushState({
                    "pageTitle": document.title,
                }, "", display_url);

                var searchFilterActive = false;
                if ($('#search').hasClass('searchFilterActive')) {
                    searchFilterActive = true;
                }

                $("#searchFormWrap").html(response);
                $("#search").html(response);

                if (searchFilterActive == true) {
                    $('#search').addClass('searchFilterActive');
                    $('.searchFilter').addClass('active');
                }

            } else if (searchType === 'searchForm') {
                $("#searchFormWrap").html(response);

                if ($('.js_searchLoadMore').length) {
                    searchLinksLoadMore();
                }
            }

            textSubstr();

            storefrontPopup();

            searchItemSlider();

            searchKeyFeaturesLengthCheck();

            reviewsOverlaySmall();

            fullReviewsOverlay();

            financeVideoOverlay();

            getLiked();

            srp_slider();

            if ($('#search').data('active') !== undefined && $('#search').data('active') !== '') {
                $('#search').find('#' + $('#search').data('active')).addClass('activePopup').find('.popup').show();
                console.log('#' + $('#search').data('active'));
            }

            if (remove && remove.match(/^AT2_M((in)|(ax))imum_Price_GBP$/)) {
                ajaxSearch(url, searchType, remove + '_Monthly');
            }

            if ($(window).width() <= window.breakpoints.mobile && $('#search').hasClass('searchFilterActive')) {
                $('.searchFilter').show();
                $('.js_triggerRefine').addClass('active');
            }

            if ($(window).width() <= 1023 && $(window).width() > 670) {
                $('.showFormTab').addClass('showForm');
                $('.formWrap form').addClass('showForm').css('left', '0');
            }

            $('.js_showFormTab').on('click', function() {

                var search_form = $(this).parents('form'),
                    position_amount = search_form.outerWidth() - 20;

                if($(this).hasClass('showForm')) {
                    $(this).removeClass('showForm');
                    $(this).parent('#searchForm').removeClass('showForm');
                    $(this).parent('#searchForm').addClass('shakeForm');
                } else {
                    $(this).addClass('showForm');
                    $(this).parent('#searchForm').addClass('showForm');
                    $(this).parent('#searchForm').removeClass('shakeForm');
                    position_amount = 0;
                }

                search_form.animate({
                    left: '-' + position_amount
                });
            });
        }
    });
}

/**
 * Postcode regex allowing spaces and lowercase from http://stackoverflow.com/a/7259020/635522
 *
 * @param postcode
 * @returns {Array|{index: number, input: string}|*}
 */
window.validatePostcode = function validatePostcode(postcode) {

    /* ------------------------------ */
    /* force strict mode  */
    /* ------------------------------ */
    "use strict";

    return postcode.match(/^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/);
}

/* ------------------------------ */
/* Cash Price or Monthly Payment Check   */
/* ------------------------------ */
window.checkCashOrMonthly = function checkCashOrMonthly(changed) {

    /* ------------------------------ */
    /* force strict mode  */
    /* ------------------------------ */
    "use strict";

    changed = typeof changed !== 'undefined' ? changed : false;
    var cash_select = 'on'

    var type = '';
    if ($('.heroTabContent:visible:first .checkboxToggle').data('type')) {
        type = $('.heroTabContent:visible:first .checkboxToggle').data('type');
    }

    if (type != '') {

        var current_tab = $('.heroTabContent.active');

        type = current_tab.find('.checkboxToggle').attr('data-type');

        if (type == 'cash' && changed) {
            type = 'monthly';
        } else if (changed) {
            type = 'cash';
        }

        if (changed && type) {
            current_tab.find('.checkboxToggle').removeAttr('data-type');

            current_tab.find('.checkboxToggle').attr('data-type', type);
        }

        if (type == 'cash') {

            current_tab.find('.cashLabel').addClass('active');
            current_tab.find('.monthlyLabel').removeClass('active');
            current_tab.find('.monthlyPaymentOptions').hide();
            current_tab.find('.cashPriceOptions').show();
        } else if (type == 'monthly') {

            current_tab.find('.checkboxToggle').prop('checked', true);

            current_tab.find('.monthlyLabel').addClass('active');
            current_tab.find('.cashLabel').removeClass('active');
            current_tab.find('.cashPriceOptions').hide();
            current_tab.find('.monthlyPaymentOptions').show();
        }

    } else {

        if ($('.checkboxToggle').is(':checked')) {
            $('.monthlyLabel').addClass('active');
            $('.cashLabel').removeClass('active');
            $('.cashPriceOptions').stop(true, false).fadeOut(function () {
                $('.monthlyPaymentOptions').stop(true, true).fadeIn();
            });
            cash_select = 'off';
        } else {
            $('.cashLabel').addClass('active');
            $('.monthlyLabel').removeClass('active');
            $('.monthlyPaymentOptions').stop(true, false).fadeOut(function () {
                $('.cashPriceOptions').stop(true, true).fadeIn();
            });
        }
    }

    if (changed) {

        $.ajax({
            url: '/modules/Search/payment_toggle_ajax.php',
            data: { is_cash: cash_select },
            type: "get",
            success: function (response) {

                //clear price if one is currently set
                if (window.location.pathname.match(/\/price-m((in)|(ax))\//) /*main search*/) {
                    ajaxSearch($('#resultSwitchView').data('url'));
                } else {
                    $("#searchForm .cashPriceOptions select").each(function (index, value) {
                        if ($(value).data('remove')) {
                            ajaxSearch($('#resultSwitchView').data('url'), 'searchForm', $(value).data('type'));
                        }
                    });
                }

            }
        });

    }
}

window.storefrontPopup = function storefrontPopup() {
    // storefront popup
    $('.js_storefrontPopup').mtcOverlay({
        buttonHtml: '<div class="overlayCloseButton storefrontPopupClose"><a href="#"><img src="/sites/petervardy/images/svgs/times-regular-white.svg" alt="Close Popup" /></a></div>',
        contentClass: 'storefrontPopup',
        padding: '16px',
        beforeOpen: function () {
            $('.overlayBox .breadcrumbWrap').remove();
            $('.overlayBox .itemKeySpecialOffer').remove();
            $('.overlayBox .contactGroupNew').remove();
            $('.overlayBox .itemLocationWrap').remove();

            // updating utm campaign / medium value as this is on search results page at this stage
            // T118749 the controller should be setting utm fields correctly
            //$('.overlayBox form input[name="utm_medium"]').val('SRP');
            //$('.overlayBox form input[name="utm_campaign"]').val('Get started');
        }
    });
}

window.searchFilterOpen = function searchFilterOpen() {
    $('html').addClass('filterActive');

    setTimeout(function() {
        $('.searchFilter').addClass('active');
    }, 300)
}

window.searchItemSlider = function searchItemSlider() {
    let custom_arrow = $('.js_customSlickArrow');

    function searchItemSliderInit(direction, slider, element) {
        let item_image_slider = slider;

        item_image_slider.slick({
            lazyLoad: 'ondemand',
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '<a class="slick-next"><img src="/sites/petervardy/images/svgs/angle-right-regular.svg" alt="Next Image"/></a>',
            prevArrow: '<a class="slick-prev"><img src="/sites/petervardy/images/svgs/angle-left-regular.svg" alt="Previous Image"/></a>',
            adaptiveHeight: false
        });

        if (direction) {
            item_image_slider.addClass('displaySlider');
            item_image_slider.slick(direction);
            element.parents('.itemImageWrap').find('.js_searchImage').addClass('hideImage');
            element.remove();
        }
    }

    custom_arrow.on('click', function (e) {
        e.preventDefault();

        let direction = $(this).data('direction'),
            slider = $(this).parent().find('.js_itemMobileImages');

        searchItemSliderInit(direction, slider, $(this));
    });
}

window.loadDesktopMobileFilter = function loadDesktopMobileFilter() {

    'use strict';

    var mobile = 0,
        current_url = window.location.pathname,
        filter_loaded = false;

    current_url = current_url.replace(/\/search\/?/, "/ajax-search/");

    if ($('#search').length > 0 && $('#search.bot').length === 0) {

        if ($(window).width() <= 1060) {
            mobile = 1;
        }

        textSubstr();

        storefrontPopup();

        searchItemSlider();

        searchKeyFeaturesLengthCheck();

        reviewsOverlaySmall();

        fullReviewsOverlay();

        financeVideoOverlay();

        getLiked();

        srp_slider();

        if ($('.heritage').length && $(window).width() <= 1060) {

            $.ajax({
                type: 'post',
                url: current_url,
                data: {
                    ajax: true,
                    mobile: mobile,
                    filter_only: 1
                },
                success: function (response) {
                    $('#searchFilterAjaxWrap').html(response);
                    checkCashOrMonthly();
                }
            });
        }

        $(document).on('click', '.js_openSlideFilter', function(e) {
            e.preventDefault();

            if ($(window).width() <= 1060) {
                mobile = 1;
            }

            if (filter_loaded !== true) {

                $.ajax({
                    type: 'post',
                    url: current_url,
                    data: {
                        ajax: true,
                        mobile: mobile,
                        filter_only: 1
                    },
                    beforeSend: function () {
                        $('#loadingOverlay').fadeIn();
                    },
                    success: function (response) {
                        $('#searchFilterAjaxWrap').html(response);

                        checkCashOrMonthly();

                        searchFilterOpen();

                        $('#loadingOverlay').fadeOut();
                    },
                    complete: function () {
                        filter_loaded = true;
                    }
                });
            } else {
                searchFilterOpen();
            }
        });


    } else {
        $('#loadingOverlay').hide();
    }
}

window.removeSideFilterClasses = function removeSideFilterClasses() {
    $('.js_searchFilterWrap').removeClass('open');
    $('#search').removeClass('searchFilterActive');
    $('body').removeClass('noScroll sideFilterOpen');
}

$(document).ready(function () {

    /* ------------------------------ */
    /* force strict mode  */
    /* ------------------------------ */
    "use strict";

    // new ux search 2020
    $(document).on('click', '.js_openFilterOption', function (e) {

        if (!$(this).parent().hasClass('active')) {
            $(this).parent().toggleClass('open');
            $(this).next('.optionsWrapper, .filterElementWrap').slideFadeToggle(300);
        } else {
            $(this).parent().removeClass('active');
            $(this).next('.optionsWrapper, .filterElementWrap').removeClass('active');

            // quick workaround for slideFadeToggle not closing properly when active is set first
            $(this).next('.optionsWrapper, .filterElementWrap').css({
                'display': 'block'
            });

            $(this).next('.optionsWrapper, .filterElementWrap').slideFadeToggle(300);

            console.log('in here');
        }
    });

    $(document).on('click', '.js_sideFilterToggle', function (e) {
        $('.js_searchFilterWrap').addClass('open');
        $('body').addClass('noScroll sideFilterOpen');
    });

    $(document).on('click', '.js_filteringComplete', function (e) {
        removeSideFilterClasses();
    });

    //anchor tags
    $(document).on('click', '#search a[data-url]', function (e) {
        e.preventDefault();

        if (!$(this).parents('li').hasClass('disabled')) {
            ajaxSearch($(this).data('url'));

            if (!$(this).parents('ul').hasClass('searchPagination')) {
                $(this).parents('#search').addClass('searchFilterActive');
            }
        }
    });

    //radio buttons
    $(document).on('change', '#search input[type=radio]', function () {
        ajaxSearch($(this).data('url'));
    });

    $(document).on('click', '.js_updateResults', function () {
        if ($(window).width() < window.breakpoints.mobile) {
            $('#search').toggleClass('searchFilterActive');

            $('.js_tabletRefineBG').toggleClass('showMe');
            $('#search .searchFilter').toggleClass('open');
        }
    });

    //load in search filter
    if ($('.js_previewSearch').length) {
        $('#loadingOverlay').fadeOut();
    } else {

        if (!$('#searchVue').length) {
            loadDesktopMobileFilter();
        }

        $(document).on('click', '.js_triggerRefineFilter', function() {
            var speed = 0,
                only_scroll_to = false,
                $this = $(this),
                scroll_element = '';

            if ($('.mobileNavBlock').hasClass('fixed')) {
                speed = 800;

                if ($('.searchFilter').is(':visible')) {
                    only_scroll_to = true;
                }
            }

            if ($.browser.safari) {
                scroll_element = $('body');
            } else {
                scroll_element = $('html');
            }

            if ($('.mobileNavBlock').hasClass('fixed')) {
                speed = 800;

                if ($('.searchFilter').is(':visible')) {
                    only_scroll_to = true;
                }
            }

            // scroll to the top then show the form
            scroll_element.stop(true, false).animate({
                scrollTop: 0
            }, speed , function () {

                if (only_scroll_to === false) {
                    $this.toggleClass('active');

                    $('.flyoutWrap').slideUp(function () {
                        $('.flyout').removeClass('alive');
                        $('.tabsNav ul li a').removeClass('active');
                        $('#search .searchFilter').slideToggle();
                    });
                }
            });
        });
    }

    //search refine on tablet
    $(document).on('click', '.js_tabletRefineBG', function () {
        $('#search').removeClass('searchFilterActive');

        $('.js_tabletRefineBG').removeClass('showMe');
        $('#search .searchFilter').removeClass('open');
    })

    $(document).on('click', '.js_tabletRefine', function () {
        $('html, body').animate({scrollTop: 0}, 'slow');
        $('#search').addClass('searchFilterActive');

        $('.js_tabletRefineBG').toggleClass('showMe');
        $('#search .searchFilter').toggleClass('open');
    })

    $(document).on('click', '.js_triggerRefineFilter', function () {
        $('html, body').animate({scrollTop: 0}, 'slow');
        $('#search').addClass('searchFilterActive');

        $('.js_tabletRefineBG').toggleClass('showMe');
        $('#search .searchFilter').toggleClass('open');
    })

    //select boxes
    $(document).on('change', '#search select', function (e) {

        var active_block = $(this).parents('.element').attr('id');

        $(this).parents('#search').data('active', active_block);

        if ($(this).parents('.searchFilter, .js_searchFilterWrap').length > 0) {
            $(this).parents('#search').addClass('searchFilterActive');
        } else {
            $(this).parents('#search').removeClass('searchFilterActive');
            $('.js_triggerRefine').removeClass('active');
        }
        ajaxSearch($("option:selected", this).data('url'));

    });

    $(document).on('keypress', '#search, #searchForm', function (e) {

        var key_code;

        key_code = e.keyCode || e.which;
        if (key_code === 13) {
            e.preventDefault();
            return false;
        }
    });

    //search form select
    $(document).on('change', 'form#searchForm select', function (e) {
        if (!$('#searchVue').length) {
            ajaxSearch($("option:selected", this).data('url'), 'searchForm');
        }
    });

    $(document).on('click', 'form#searchForm a.selectRemove', function (e) {
        e.preventDefault();
        if (!$('#searchVue').length) {
            ajaxSearch($(this).data('url'), 'searchForm');
        }
    });

    //postcode
    //This code links the focusin and keyup events to a timer that waits for nothing to happen for a given amount of
    // time - 1 sec at the time of writing - and then fires the postcode logic, which checks that either the field is
    // blank or a valid postcode has been entered before sending the ajax request to the search
    var typingTimer,
        doneTypingInterval = 100;

    $(document).on('focusin keyup click', '#searchForm input[data-type="Postcode"], #search #inputPostcode', function (e) {

        var keyCode = e.keyCode || e.which,
            $searchFormInputElement,
            $searchInputElement,
            $theInputElement,
            postcode,
            searchType,
            url;

        clearTimeout(typingTimer);
        typingTimer = setTimeout(function () {

            $searchFormInputElement = $('#searchForm input[data-type="Postcode"]');
            $searchInputElement = $('#search #inputPostcode');

            if ($searchFormInputElement.length) {
                $theInputElement = $searchFormInputElement;
            } else if ($searchInputElement.length) {
                $theInputElement = $searchInputElement;
            }

            postcode = ($theInputElement.val()).replace(/\s/g, '');

            //only trigger the postcode ajax call if a valid postcode was either entered (set it) or deleted (remove it)
            if ((validatePostcode(postcode) && (String.fromCharCode(keyCode).match(/[A-Za-z0-9 ]/i) || keyCode == 13 || keyCode == 16)) || (!postcode && (keyCode == 8 /*backspace*/ || keyCode == 46 /*delete*/))) {

                if ($searchFormInputElement.length) {
                    url = ($theInputElement.data('url').replace(/\/postcode\/[^/]+\/?/, '\/') + '/postcode/' + postcode).replace(/\/{2,}/g, '\/');
                    searchType = 'searchForm';
                } else if ($searchInputElement.length) {
                    url = (window.location.pathname + '/' + $searchInputElement.data('url') + '/' + postcode).replace(/\/{2,}/g, '\/');
                    searchType = undefined;
                }

                if (!$('#searchVue').length) {
                    ajaxSearch(url, searchType);
                }
            }
        }, doneTypingInterval);
    });

    $(document).on('keydown', '#searchForm input[data-type="Postcode"], #search #inputPostcode', function (e) {
        clearTimeout(typingTimer);
    });

    //Selecting the element for popup
    $(document).on('click', '.element.popup_list h2', function (e) {
        //only trigger when popup is not already active and options are avaiable
        if (!$(this).parents('.popup_list').hasClass("optionSelected") && !$(this).parents('.popup_list').hasClass('activePopup') && !$(this).parents('.popup_list').hasClass('empty')) {

            //remove active class of all popups and hide them all too
            $('.activePopup').removeClass('activePopup');
            $('.optionsToSelect .popup.list, .popup.range').fadeOut();

            // add active class to selected popup and fade it in
            $(this).parents('.popup_list').addClass('activePopup');
            $(this).parents('.popup_list').find('.popup.list').fadeIn();
        }
    });

    //add error if postcode is wrong
    $(document).on('click', '#searchSubmit', function (e) {
        var postcode = $('#formPostcode');

        if (postcode.val() && !validatePostcode(postcode.val())) {
            e.preventDefault();
            if (!$('#postcodeError').length) {
                $('<p class="error hideme" id="postcodeError">The postcode you have entered is not valid</p>').insertBefore(postcode.closest('.halfRows')).fadeIn();
            }
        }
    });

    //Selecting the element for popup
    $(document).on('click', '.element.popup_range h2', function (e) {
        //only trigger when popup is not already active and options are avaiable
        if (!$(this).parents('.popup_range').hasClass('activePopup') && !$(this).parents('.popup_range').hasClass('empty')) {

            //remove active class of all popups and hide them all too
            $('.activePopup').removeClass('activePopup');
            $('.popup.range, .popup.list').fadeOut();

            // add active class to selected popup and fade it in
            $(this).parents('.popup_range').addClass('activePopup');
            $(this).parents('.popup_range').find('.popup.range').fadeIn();
        }
    });

    //Clicking close on popup
    $(document).on('click', '.popup_list .closePopup, .popup_range .closePopup', function (e) {
        $('.activePopup').removeClass('activePopup');
        $('.popup.list, .popup.range').fadeOut();
        $('#search').data('active', '');
        killclick(e);
    });

    //When filter applied from list scroll to top
    $(document).on('click', '.popup_list a', function (e) {
        e.preventDefault();

        if ($(window).width() > window.breakpoints.tablet) {
            $('html, body').animate({scrollTop: 0}, 'slow');
        }
    });

    //When pagination used scroll to top
    $(document).on('click', '.bottomPagination .searchPagination a', function (e) {
        $('html, body').animate({scrollTop: 0}, 'slow');
        killclick(e);
    });

    //When a range is closed sfter selected scroll to top
    $(document).on('click', '.popup_range .closePopup', function (e) {

        if ($(this).parents('.popup').find('.selectRemove').length > 0) {
            $('html, body').animate({scrollTop: 0}, 'slow');
        }
        killclick(e);
    });

    //Toggle make info on mobile
    $(document).on('click', '.readmore', function (e) {
        $('.description, .rightBanner, .readless').slideDown();
        $(this).hide();
    });

    $(document).on('click', '.readless', function (e) {

        $('.description, .rightBanner').slideUp();
        $(this).hide();
        $('.readmore').show();
    });

    //checkCashOrMonthly();

    $('body').on('change', '.checkboxToggle', function (e) {
        e.stopPropagation();
        checkCashOrMonthly(true);
    });

    $('body').on('swipe', 'div.checkboxToggleWrap', function () {
        $('.checkboxToggle').trigger('click');
    });

    $('body').on('click', '.js_updateResults', function (e) {
        if ($(window).width() < window.breakpoints.mobile) {
            $('.js_triggerRefine').trigger('click');
            $('html, body').animate({scrollTop: 0}, 'slow');
        } else {
            $('.js_tabletRefineBG ').trigger('click');
            $('html, body').animate({scrollTop: 0}, 'slow');
        }
    });

    $('body').on('click', '#filter .close', function (e) {
        $('.js_tabletRefineBG ').trigger('click');
        $('html, body').animate({scrollTop: 0}, 'slow');
    });

    $(document).scroll(function() {
        if($('.js_stickySearchBar').length > 0) {
            var $element = $('.js_stickySearchBar'),
                header_height = ($('#header').height()) + ($('.keyMessageBanner').height()) + ($('.searchResults .bannerWrapper').height());
            if ($(document).scrollTop() >= header_height /*&& !is_touch_device()*/) {
                // user scrolled passed header
                $element.addClass('showMe');
            } else {
                $element.removeClass('showMe');
            }
        }
    });

});

$(window).on('resize', debouncer(function (e) {

    "use strict";

    if ($(window).width() <= window.breakpoints.mobile && $('.searchFilter').hasClass('mobile')) {
        //do nothing
    } else if ($(window).width() > window.breakpoints.mobile && !$('.searchFilter').hasClass('mobile')) {
        //do nothing
    } else {
        if ($('.js_previewSearch').length) {
            $('#loadingOverlay').fadeOut();
        } else {
            // loadDesktopMobileFilter();
        }
    }

    if ($(window).width() > window.breakpoints.mobile) {
        $('.searchFilter').attr('style', '');
    }

})); // window resize
